import { Link, NavLink, Route, Routes, useParams } from 'react-router-dom';
import { useTenant, api } from '../../lib/api';
import { Wordmark } from '../Login';
import UserOverview from './UserOverview';
import UserMailboxes from './UserMailboxes';
import UserDomainSwap from './UserDomainSwap';

/** Customer (role=user) tenant detail. Three tabs only — Overview /
 * Mailboxes / Domain swap. No Phases tab (hidden raw orchestrator detail),
 * no Logs tab (operator surface). The pipeline progress bar lives at the
 * top of Overview. */
export default function UserTenantView() {
  const { id = '' } = useParams();
  const { data: t, isLoading } = useTenant(id);

  if (isLoading) return <div className="p-8 text-dim text-sm">Loading…</div>;
  if (!t) return <div className="p-8 text-dim text-sm">Tenant not found.</div>;

  const tab = (to: string, label: string) => (
    <NavLink
      to={to}
      end={to === '.'}
      className={({ isActive }) =>
        `px-4 py-3 text-sm border-b-2 -mb-px transition ${
          isActive ? 'border-accent text-ink' : 'border-transparent text-dim hover:text-ink'
        }`
      }
    >
      {label}
    </NavLink>
  );

  return (
    <div className="min-h-full flex flex-col">
      <header className="border-b border-line">
        <div className="max-w-5xl mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/dashboard" className="hover:opacity-80 transition">
            <Wordmark className="h-5" />
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/dashboard" className="text-xs text-dim hover:text-ink transition">← All tenants</Link>
            <button
              onClick={async () => { await api.logout(); window.location.href = '/'; }}
              className="btn-ghost btn-sm"
            >Sign out</button>
          </div>
        </div>
      </header>

      <div className="max-w-5xl w-full mx-auto px-8 pt-6">
        <h1 className="text-xl font-semibold tracking-tight">{t.target_domain}</h1>
        <p className="text-xs text-dim font-mono mt-1">{t.ga_upn}</p>
      </div>

      <nav className="border-b border-line mt-4">
        <div className="max-w-5xl mx-auto px-8 flex">
          {tab('.', 'Overview')}
          {tab('mailboxes', 'Mailboxes')}
          {tab('domain-swap', 'Domain swap')}
        </div>
      </nav>

      <div className="flex-1">
        <div className="max-w-5xl mx-auto">
          <Routes>
            <Route index element={<UserOverview />} />
            <Route path="mailboxes" element={<UserMailboxes />} />
            <Route path="domain-swap" element={<UserDomainSwap />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
